(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-eveora-body-adhesive-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  var NS = 'page-eveora-body-adhesive-hero';
  if (window.__eveoraHeroGallery) return;
  window.__eveoraHeroGallery = true;

  function stripOf(sec) { return sec ? sec.querySelector('.' + NS + '__g_main') : null; }
  function thumbsOf(sec) { return Array.prototype.slice.call(sec.querySelectorAll('.' + NS + '__g_thumb')); }

  document.addEventListener('click', function (e) {
    var nav = e.target.closest('.' + NS + '__gnav');
    if (nav) {
      var g = stripOf(nav.closest('.' + NS + '__hero_sec'));
      if (g) g.scrollBy({ left: (parseInt(nav.getAttribute('data-dir'), 10) || 1) * g.clientWidth, behavior: 'smooth' });
      return;
    }
    var th = e.target.closest('.' + NS + '__g_thumb');
    if (!th) return;
    var sec = th.closest('.' + NS + '__hero_sec');
    var g2 = stripOf(sec);
    if (!g2) return;
    var ths0 = thumbsOf(sec);
    var off0 = g2.querySelectorAll('.' + NS + '__g_slide').length - ths0.length;
    if (off0 < 0) off0 = 0;
    g2.scrollTo({ left: (ths0.indexOf(th) + off0) * g2.clientWidth, behavior: 'smooth' });
  });

  var raf = null;
  document.addEventListener('scroll', function (e) {
    var g = e.target;
    if (!g.classList || !g.classList.contains(NS + '__g_main')) return;
    if (raf) return;
    raf = requestAnimationFrame(function () {
      raf = null;
      var sec = g.closest('.' + NS + '__hero_sec');
      if (!sec) return;
      var ths = thumbsOf(sec);
      if (!ths.length) return;
      var off = g.querySelectorAll('.' + NS + '__g_slide').length - ths.length;
      if (off < 0) off = 0;
      var idx = Math.round(g.scrollLeft / g.clientWidth) - off;
      if (idx < 0) idx = 0;
      if (idx > ths.length - 1) idx = ths.length - 1;
      ths.forEach(function (x, i2) { x.classList.toggle(NS + '__on', i2 === idx); });
      ths[idx].scrollIntoView({ block: 'nearest', inline: 'nearest' });
    });
  }, true);

  function syncPrice() {
    document.querySelectorAll('.' + NS + '__hero_sec').forEach(function (sec) {
      var priceEl = sec.querySelector('.' + NS + '__price');
      if (!priceEl) return;
      var checked = sec.querySelector('.' + NS + '__tier input:checked');
      var tier = checked && checked.closest('.' + NS + '__tier');
      var tp = tier && tier.querySelector('.' + NS + '__tprice');
      if (tp) priceEl.textContent = tp.textContent.trim();
    });
  }
  document.addEventListener('change', function (e) {
    if (e.target.closest && e.target.closest('.' + NS + '__tier')) syncPrice();
  });
  syncPrice();

  function paintRating(scope) {
    var spans = (scope || document).querySelectorAll('.' + NS + '__rating > span:not(.' + NS + '__hearts)');
    spans.forEach(function (sp) {
      (function walk(node) {
        Array.prototype.slice.call(node.childNodes).forEach(function (n) {
          if (n.nodeType === 3) {
            if (!/[0-9.,\/]/.test(n.nodeValue)) return;
            var frag = document.createDocumentFragment();
            n.nodeValue.split(/([0-9.,\/]+)/).forEach(function (part, i) {
              if (!part) return;
              if (i % 2) {
                var s = document.createElement('span');
                s.className = NS + '__ratnum';
                s.textContent = part;
                frag.appendChild(s);
              } else {
                frag.appendChild(document.createTextNode(part));
              }
            });
            node.replaceChild(frag, n);
          } else if (n.nodeType === 1 && n.className !== NS + '__ratnum') {
            walk(n);
          }
        });
      })(sp);
    });
  }
  paintRating();
  document.addEventListener('shopify:section:load', function (e) { paintRating(e.target); syncPrice(); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-eveora-body-adhesive-social-proof"] && !Shopify.designMode) return;
  try {
    
(function () {
  var NS = 'page-eveora-body-adhesive-social-proof';
  if (window.__eveoraRevDrag) return;
  window.__eveoraRevDrag = true;
  var drag = null;
  document.addEventListener('pointerdown', function (e) {
    if (e.pointerType !== 'mouse') return;
    var g = e.target.closest('.' + NS + '__rev_grid');
    if (!g || g.scrollWidth <= g.clientWidth) return;
    drag = { g: g, x: e.clientX, sl: g.scrollLeft };
    g.classList.add(NS + '__dragging');
    e.preventDefault();
  });
  document.addEventListener('pointermove', function (e) {
    if (!drag) return;
    drag.g.scrollLeft = drag.sl - (e.clientX - drag.x);
  });
  ['pointerup', 'pointercancel'].forEach(function (t) {
    document.addEventListener(t, function () {
      if (!drag) return;
      drag.g.classList.remove(NS + '__dragging');
      drag = null;
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
